import { render, staticRenderFns } from "./ClinicOpeningHours.vue?vue&type=template&id=ab02de92&scoped=true&"
import script from "./ClinicOpeningHours.vue?vue&type=script&lang=js&"
export * from "./ClinicOpeningHours.vue?vue&type=script&lang=js&"
import style0 from "./ClinicOpeningHours.vue?vue&type=style&index=0&id=ab02de92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab02de92",
  null
  
)

export default component.exports